import * as React from 'react'

/**
 * @description Fingerprint icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Fingerprint } from '@sravni/design-system-icons'
 *
 * <Fingerprint />
 * ```
 */
export const Fingerprint = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Fingerprint" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.542 17.377a9.575 9.575 0 0 1-1.808-5.602c0-2.7 2.239-4.887 5-4.887s5 2.188 5 4.887"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.004 16.65c-.09.004-.178.012-.269.012-2.761 0-5-2.188-5-4.887"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.774 18c-2.124-1.294-3.539-3.598-3.539-6.225 0-1.35 1.12-2.444 2.5-2.444 1.381 0 2.5 1.094 2.5 2.444 0 1.35 1.12 2.444 2.501 2.444 1.38 0 2.5-1.094 2.5-2.444 0-4.05-3.358-7.331-7.5-7.331-4.142 0-7.5 3.282-7.5 7.331 0 .903.104 1.782.294 2.629"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.715 5.09A9.369 9.369 0 0 0 10.735 2a9.369 9.369 0 0 0-6.981 3.09"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
